export default __webpack_public_path__ + "static/0624_2024_eves_eszr_20250514164814_hu-03beedce7debef08fca5c278c40b31f0.pdf";